/** Ortak sorumluların (birincil hariç) küçük avatar yığını. */
import { UserAvatar } from "../users/UserAvatar";

export function CoAssigneeAvatars({ task, users }) {
  const co = (task.assignee_ids || []).filter(
    (id) => id && id !== task.assignee_id,
  );
  if (co.length === 0) return null;
  const resolved = co
    .map((id) => users.find((u) => u.id === id))
    .filter(Boolean);
  if (resolved.length === 0) return null;
  return (
    <span
      className="flex items-center -space-x-1.5"
      data-testid={`co-assignees-${task.id}`}
      title={resolved.map((u) => u.name).join(", ")}
    >
      {resolved.slice(0, 3).map((u) => (
        <UserAvatar
          key={u.id}
          name={u.name}
          email={u.email}
          size="xs"
          className="ring-1 ring-white"
        />
      ))}
      {resolved.length > 3 && (
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-zinc-100 text-[9px] font-bold text-zinc-600 ring-1 ring-white">
          +{resolved.length - 3}
        </span>
      )}
    </span>
  );
}
